exports.baseURL = "https://admin.ajobfun.cloud/";
exports.key = "BS67Rfb0Tf";
exports.projectName = "AjubLive"
